import { BackendAdapterBragg } from "@spawn/backend-adapter-bragg";
import { consumer, inject } from "@spawn/core";
import { IBraggResponseFreegameEvent } from "@spawn/freegames";
import { BraggSlotfaceRestoreService } from "@spawn/reveal";
import { NudgeUpService } from "../../services/nudgeUpService";
import { CacheKeys, CacheStorage } from "../../utils/cacheStorage";
import { IGameNetworkState } from "../networkState";
import { NrgBraggFreegameResult } from "../types/bragg";
import { FGSpinActionBragg } from "./fgSpinActionBragg";

/**
 * Specs say Free games should start with a new reelset that includes mystery symbols on reels 2 and 4.
 * This is where we set that up.
 */
@consumer
export class FGInitActionBragg extends FGSpinActionBragg {
	@inject protected readonly braggSlotfaceRestoreService!: BraggSlotfaceRestoreService;
	@inject protected readonly nudgeUpService!: NudgeUpService;

	protected override parse(response: IBraggResponseFreegameEvent, adapter: BackendAdapterBragg): IGameNetworkState {
		const result = super.parse(response, adapter);
		const {
			data: { FREE_SPIN },
		} = response.body as NrgBraggFreegameResult;

		CacheStorage.set(CacheKeys.FirstFGSpinResponse, response);

		// assumptions:
		// by default all freegames should start with reels 2 and 4 full of mystery symbols
		// => so we look at the reveals being given for reel 2
		// => if we get 4 reveals, we had 0 extra scatters
		// => if we get 3 reveals, we had 1 extra scatter
		// and so on

		const extraScatters = 4 - FREE_SPIN.reveals.filter((x) => x.reelPos === 1).length;

		// create nudge up before spinning
		const { intermediateReels, finalReels } = this.nudgeUpService.createNudgeInitialState(
			result.slotGameBase.reels,
			extraScatters
		);

		// we mock the initial fg state to have only basic nudging and reveal data for the first spin
		const mockInitialState: IGameNetworkState = {
			...result,
			slotGameBase: {
				...result.slotGameBase,
				reels: finalReels,
			},
			nudging: [0, 1, 0, 1, 0],
			reveal: {},
			preNudgeUpReels: intermediateReels,
		};

		return mockInitialState;
	}
}
